import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const LastPage: FC<SvgIconProps> = (props) => (
  <SvgIcon width="24" height="24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4648 12.0017L7 7.33243L8.5461 6L13 12.0022L8.54586 18L7.00024 16.6669L10.4648 12.0017Z"
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M15 18L15 6L17 6L17 18L15 18Z" />
  </SvgIcon>
)
